import {FrequencyType} from "@app/shared/enums/frequency-type.enum";

export class TimesheetPeriod {
  id: number;
  version: number;

  frequency: FrequencyType;
  name: string;
  period: string;
  year: string;
  start: string;
  end: string;
  orgId: number;
}

export class TimesheetOvertimeConfig {
  id?: number;
  version?: number;
  year: string;
  workingHoursPerWeek: number;
  workingHoursPerDay: number;
  userId: number;
  timesheetPeriodId: number;
  txnNumber?: string;
  userFullName: string;
  periodDisplay: string;
  periodNumber: number;
  periodStart: string;
}

export class OverTimeConfigParams {
  userId: number;
  firstLongWeek: number;
  longWeekWorkingHours: number;
  firstShortWeek: number;
  shortWeekWorkingHours: number;
  year: string;
}
